<router-outlet></router-outlet>
@if (loading) {
  <app-loader></app-loader>
}